import { render, staticRenderFns } from "./ProviderButton.vue?vue&type=template&id=f698f132"
import script from "./ProviderButton.vue?vue&type=script&lang=js"
export * from "./ProviderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports